import { BASE_PATH } from "@/const/config";

export default {
  computed: {
    linkYonimo() {
      return "https://www.fujitv.co.jp/kimyo/";
    },
    linkTop() {
      return BASE_PATH;
    },
    shareUrl() {
      return `${location.origin}${BASE_PATH}`;
    },
    shareText() {
      return "あなたの名前を_∴縺_ください";
    },
    shareHashtags() {
      return ["あなたの鐔ｭЖ_診断", "世にも奇妙な物語"];
    }
  }
};
